/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:31/07/2021
 @Time:11:22
 **/
import TranslationService from "./service/TranslationService";
$(function(){
    TranslationService.getInstance();//initialize instance et lance le téléchargement des fichiers de traductions + et on le met dans le cache de navigateur
});